module.exports = __webpack_public_path__ + "img/step6.bea590a0.png";